import { api } from '../axios';
import type {
  AuthConstants,
  IUser,
  LoginRequest,
  LoginResponse,
  LoginWithRequest,
  RegisterRequest,
  VkAuthCode,
} from '../../types/user';

class AuthService {
  private baseUrl = '/platform/api/v1/auth';

  async register(requestDataItem: RegisterRequest) {
    return await api.post<IUser>(`${this.baseUrl}/users/`, requestDataItem);
  }

  async login({ username, password }: LoginRequest) {
    return await api.postForm<LoginResponse>(`${this.baseUrl}/token`, {
      username,
      password,
    });
  }

  async getCurrent() {
    return await api.get<IUser>(`${this.baseUrl}/users/me/`);
  }

  async verifyEmail(token: string) {
    return await api.get<{ message: string }>(`${this.baseUrl}/verify-email?token=${token}`);
  }

  async resetPassword(token: string, password: string) {
    return await api.post<{ message: string }>(`${this.baseUrl}/reset-password`, {
      token,
      password,
    });
  }

  async sendVerificationLink(email: string) {
    return await api.post<{ message: string }>(`${this.baseUrl}/send-link`, {
      email,
      type: 'verify_email',
    });
  }

  async sendResetLink(email: string) {
    return await api.post<{ message: string }>(`${this.baseUrl}/send-link`, {
      email,
      type: 'reset_password',
    });
  }

  async loginWithYandex({ access_token }: LoginWithRequest) {
    return await api.post<LoginResponse>(`${this.baseUrl}/yandex-id`, {
      access_token,
    });
  }

  async loginWithVk(data: VkAuthCode) {
    return await api.post<LoginResponse>(`${this.baseUrl}/vk-id`, data);
  }

  getAuthConfig = async () =>
    await api.get<{
      type: string;
      json: AuthConstants;
    }>('/platform/api/v1/config/auth');
}

export const authService = new AuthService();
